import { render, staticRenderFns } from "./ViewOtherLoanDetail.vue?vue&type=template&id=5f94431b"
import script from "./ViewOtherLoanDetail.vue?vue&type=script&lang=js"
export * from "./ViewOtherLoanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports